/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// DateJS-backed dynamic date input widget and utilities

namespace('Slzr.UI.DateField', function(exports, top) {
  const $ = Slzr.jQuery;
  const {
    jQuery
  } = Slzr;

  // Controller for date inputs
  //
  // Manages input parsing and triggers events
  class Input {
    static initClass() {
      this.prototype.default_options = {
        // Input element to attach to
        element: null,
  
        // Element to set parsed value on
        value_element: null,
  
        // Initial format for parsed dates
        initial_date_format: Slzr.Formats.ShortDate,
  
        // Initial format for parsed times
        initial_time_format: Slzr.Formats.LongTime,
  
        // Bias in date input
        bias: 'future_date'
      };
    }

    constructor(options) {
      this._inputChanged = this._inputChanged.bind(this);
      this._initializeInput = this._initializeInput.bind(this);
      this.options = $.extend({}, this.default_options, options);
      this.element = $(this.options.element);
      if (this.options.value_element) { this.value_element = $(this.options.value_element); }

      this.element.on('keyup change slzr:date_changed', this._inputChanged);

      this._initializeInput();
      this._inputChanged();
    }

    // Handler for input field being changed
    //
    // Parses the date, sets data, and triggers the appropriate events
    _inputChanged() {
      let date;
      const val = this.element.val();

      switch ((date = this._parseDate(val))) {
        case 'blank':
          this.element.data('date', null);
          this.element.data('date-status', 'blank');
          this.element.trigger('slzr:date:change', ['blank', null]);
          return (this.value_element != null ? this.value_element.val(null) : undefined);
        case 'error':
          this.element.data('date', null);
          this.element.data('date-status', 'error');
          this.element.trigger('slzr:date:change', ['invalid', null]);
          return (this.value_element != null ? this.value_element.val(null) : undefined);
        default:
          this.element.data('date', date);
          this.element.data('date-status', 'ok');
          this.element.trigger('slzr:date:change', ['valid', date]);
          return (this.value_element != null ? this.value_element.val(date.format('Y-m-d')) : undefined);
      }
    }

    // Parse the entered date and return the parsed date, 'blank', or 'error'
    _parseDate(str) {
      if (str.isBlank()) {
        return 'blank';
      } 
        let d;
        const bias = this.options.bias || 'future_date';
        if (d = Date.parse(str, {bias})) {
          return d;
        } 
          return 'error';
        
      
    }

    // Initialize the input
    //
    // Mainly will take a pre-filled date and standardize it, including 
    // "today" or "tomorrow" as appropriate.
    //
    // The initial value is expected to be either a YYYY-MM-DD formatted date for date mode, or
    // a HH:MM:SS formatted time for time mode.
    _initializeInput() {
      let d;
      const val = this.element.val();

      if (this.options.mode === 'date') {
        if (d = new Date(`${val}T00:00:00`)) {
          if (0 === Date.compare(d, Date.today())) {
            return this.element.val('Today');
          } else if (0 === Date.compare(d, Date.today().add(1).days())) {
            return this.element.val('Tomorrow');
          } 
            return this.element.val(d.toString(this.options.initial_date_format));
          
        }
      } else { // time
        if (d = new Date(val)) {
          return this.element.val(d.toString(this.options.initial_time_format));
        }
      }
    }
  }
  Input.initClass();

  // Date Preview Controller
  class Preview {
    static initClass() {
      this.prototype.default_options = {
        // The input element to sync with
        input_element: null,
  
        // The preview output element
        element: null,
  
        // The preview formats
        date_format: Slzr.Formats.LongDate,
        time_format: Slzr.Formats.LongTime,
  
        // Error messages
        date_error: 'Unknown date',
        time_error: 'Unknown time',
  
        // Mode (date or time)
        mode: 'date'
      };
    }

    constructor(options) {
      this._updatePreview = this._updatePreview.bind(this);
      this.options = $.extend({}, this.default_options, options);
      this.element = $(this.options.element);
      this.input_element = $(this.options.input_element);

      if (this.options.mode === 'date') {
        this.format = this.options.date_format;
        this.error_message = this.options.date_error;
      } else {
        this.format = this.options.time_format;
        this.error_message = this.options.time_error;
      }

      this.input_element.on('slzr:date:change.preview', this._updatePreview);
    }

    // Update the preview based on state and date
    _updatePreview(event, state, date) {
      switch (state) {
        case 'blank':   return this.element.html('');
        case 'invalid': return this.element.html(this.error_message);
        case 'valid':   return this.element.html(date.toString(this.format));
      }
    }
  }
  Preview.initClass();

  const initialize = function(el, my_options) {
    let date_error; let date_format; let initial_date_format; let initial_time_format; let time_error; let time_format;
    const input_element = $(el);
    const preview_element = (input_element.data('preview') != null) ? $(input_element.data('preview')) : my_options.preview_element;
    const value_element = (input_element.data('value') != null) ? $(input_element.data('value')) : null;
    
    if (my_options.mode === 'date') {
      date_format = input_element.data('format');
      initial_date_format = input_element.data('initial-format');
      date_error = input_element.data('date-error');
    } else {
      time_format = input_element.data('format');
      initial_time_format = input_element.data('initial-format');
      time_error = input_element.data('time-error');
    }

    const bias = input_element.data('date-bias');

    const preview_options = $.extend({
      input_element,
      element: preview_element,
      time_format,
      time_error,
      date_format,
      date_error
    }, my_options);

    const input_options = $.extend({
      element: input_element,
      value_element,
      initial_date_format,
      initial_time_format,
      bias
    }, my_options);

    if (preview_element != null) { new Preview(preview_options); }
    return new Input(input_options);
  };

   
  // Add jQuery function for attaching
  jQuery.fn.extend({
    dateInput(options) {
      const my_options = options;

      this.each(function() { return initialize(this, my_options); });
      return this;
    }
  });
  // Automatically attach to anything with data-input=date or data-input=time
  //
  // Data attributes:
  //   data-input => is this a 'date' or 'time' input
  //   data-preview => selector to the associated preview element
  //   data-format => datejs format string for preview
  //   data-initial-format => datejs format string for initial input
  //   data-date-error => "Unknown" string for invalid dates
  // 
  // Only data-input is required
  jQuery(function() {
    $('input[data-input="date"]').dateInput({mode: 'date'});
    return $('input[data-input="time"]').dateInput({mode: 'time'});
  });

  // Export everything
  exports.Input = Input;
  exports.Preview = Preview;
  return exports.initialize = initialize;
});
